import log from '../log';
import {allLogTypes as logTypes} from '@servicenow/ui-internal';

function isAlphaNumeric(str) {
	return /^[a-z]+[a-z0-9]*$/i.test(str);
}

function assertValidPropertyNames(properties) {
	if (process.env.NODE_ENV === 'development') {
		const {length: propertiesCount} = properties;
		for (let i = 0; i < propertiesCount; i++) {
			const property = properties[i];
			if (isAlphaNumeric(property) === false) {
				log(`Invalid property name ${property}`, {
					level: logTypes.ERROR,
					origin: 'assertValidPropertyNames'
				});
			}
		}
	}

	return true;
}

export default assertValidPropertyNames;
